var LOGODEV_TOKEN = 'pk_A-kn3gYxQcOlATfWyz13MQ';

function normalizeDomain(input: string | null | undefined) {
  return (input || '').trim().toLowerCase()
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .replace(/\/.*$/, '');
}
function isValidDomain(d: string) { return /^[a-z0-9.-]+\.[a-z]{2,}$/i.test(d); }

export function mountLogos() {
  if (!LOGODEV_TOKEN) return; // no token -> keep monograms
    document.querySelectorAll('[data-logo-domain]').forEach(function (el) {
      if (el.querySelector('img')) return;
      var d = normalizeDomain(el?.getAttribute('data-logo-domain' as string));
      if (!isValidDomain(d)) return;
      var img = document.createElement('img');
      img.src = 'https://img.logo.dev/' + d + '?token=' + encodeURIComponent(LOGODEV_TOKEN) + '&size=128&format=png&retina=true';
      img.alt = '';
      img.setAttribute('loading', 'lazy');
      img.onerror = function () { img.remove(); }; // fall back to monogram
      el.appendChild(img);
  });
}
